<template>
  <div>
    <list :listTitle="$t('mercadoLivre.accounts.label')" :listLogo="definitionModule.logo" filterTitle="Filtros" :typesListAvailable="['displayList']" :loading="loadingSearch || loadingAddAccount" :total="mercadoLivreAccountsTotal" :sortFields="sortFields" :sortDefault="{ field: sortFields[0], order: 'asc' }" @change="onChange">
      <div class="btnGroup" slot="header-actions">
        <button @click="mercadoLivreAuthenticate()" slot="header-actions" class="hint hint--left btn btn--info" data-label="Adicionar conta">
          <i class="icon-plus"/>
        </button>
      </div>

      <template slot="filters">
        <form-group label="Nome">
          <input class="form-input" v-model="options.name">
        </form-group>
        <form-group label="E-mail">
          <input class="form-input" v-model="options.email">
        </form-group>
      </template>

      <div class="l-col-4@md" v-for="(item, index) in mercadoLivreAccounts" :key="index">
        <account :account="item"/>
      </div>
      <div class="l-col u-textCenter" v-if="!mercadoLivreAccounts.length">
        <panel>
          Nenhuma contra foi encontrado.
        </panel>
      </div>
    </list>
    <modal-account-confirmation :account="account" v-model="modalConfirmFlag" v-on:confirm="accountConfirm"/>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import { getAllUrlParams } from '@/helper'
  import { merge } from 'lodash'
  import Loader from '@/components/template/Loader'
  import PageTitle from '@/components/template/PageTitle'
  import api from '@/api'
  import notifier from '@/notifier'
  import List from '@/components/shared/list/Paginator'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import Account from '@/components/marketplace/mercadoLivre/Account'
  import ModalAccountConfirmation from '@/components/marketplace/mercadoLivre/ModalAccountConfirmation'

  export default {
    data: () => ({
      errors: [],
      loadingAddAccount: false,
      loadingSearch: false,
      type: 'marketplace',
      identifier: 'mercadoLivre',
      options: {
        name: '',
        email: ''
      },
      sortFields: [
        'name'
      ],
      account: null,
      modalConfirmFlag: false
    }),
    mounted () {
      this.addAccountByCode(getAllUrlParams().code)
    },
    methods: {
      ...mapActions('mercadoLivreAccounts', [
        'fetchAccounts',
        'addAccount'
      ]),
      addAccountByCode (code) {
        if (code !== undefined) {
          this.loadingAddAccount = true
          api.mercadoLivre.getAccount(code)
            .then(account => {
              this.loadingAddAccount = false
              this.account = account
              this.modalConfirmFlag = true
            })
            .catch(error => {
              let message = 'Falha ao adicionar a conta.'
              if (error.response.data.message) {
                message = error.response.data.message
              }
              notifier.error(message, 'Não adicionada')
            })
            .finally(() => {
              this.loadingAddAccount = false
              this.removeCode()
            })
        }
      },
      removeCode () {
        const currentUrl = window.location.href
        if (currentUrl.indexOf('?code') !== -1) {
          this.loading = true
          const url = currentUrl.replace(currentUrl.substr(currentUrl.indexOf('?'), 140), '')
          window.location.replace(url)
        } else {
          this.loading = false
        }
      },
      mercadoLivreAuthenticate () {
        window.location.href = 'https://auth.mercadolivre.com.br/authorization?response_type=code&client_id=' + process.env.MERCADO_LIVRE_APP_ID
      },
      async onChange (options) {
        this.loadingSearch = true

        merge(this.options, options)

        await this.fetchAccounts({ options: this.options })

        this.loadingSearch = false
      },
      async accountConfirm () {
        this.loadingAddAccount = true
        api.mercadoLivre.addAccount(this.account.refreshToken)
          .then(() => {
            notifier.success('Conta adicionada com sucesso.', 'Adicionada')
            this.fetchAccounts({ options: this.options })
              .then(() => {
                this.loadingAddAccount = false
              })
          })
          .catch(error => {
            let message = 'Falha ao adicionar a conta.'
            if (error.response.data.message) {
              message = error.response.data.message
            }
            notifier.error(message, 'Não adicionada')
            this.loadingAddAccount = false
          })
      }
    },
    computed: {
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      ...mapFields({
        mercadoLivreAccountsTotal: 'mercadoLivreAccounts.total',
        mercadoLivreAccounts: 'mercadoLivreAccounts.accounts'
      }),
      definitionModule () {
        return this.getDefinitionModuleByIdentifierAndType(this.type, this.identifier)
      }
    },
    components: {
      ModalAccountConfirmation,
      Loader,
      PageTitle,
      List,
      Panel,
      FormGroup,
      Account
    }
  }
</script>

<style scoped lang="sass">
  .count-selected
    margin-top: 4px

    .logo
      max-height: 30px
      margin-right: 20px

      .title
        margin-top: 16px
        margin-left: 20px

      .paginator
        float: right
</style>



// WEBPACK FOOTER //
// List.vue?1ba525f0